import {
  EDIT_PROFILE__ADD_ADDRESS,
  ADD_CUSTOMERS,
  SELECT_CUSTOMER,
  UPDATE_CUSTOMER,
  ADD_NEW_ADDRESS,
  ADD_NEW_CUSTOMER,
  ADD_NEW_SERVICE,
  ADD_NEW_SERVICES,
  REMOVE_SERVICE,
  REMOVE_CUSTOMER_ADDRESS,
  SELECT_ORDER,
  ADD_NEW_ORDER,
  ADD_NEW_DRIVER,
  ADD_NEW_DRIVERS,
  REMOVE_DRIVER,
  SELECT_DRIVER,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
  API_CALL_REQUEST,
  API_SEND_SMS_SUCCESS,
  API_SEND_SMS_FAILURE,
  API_SEND_SMS_REQUEST,
  ADD_NEW_CUSTOMER_STATE,
  ADD_NEW_SERVICE_STATE,
  REMOVE_SERVICE_STATE,
  ADD_NEW_DRIVER_STATE,
  REMOVE_DRIVER_STATE,
  REMOVE_CUSTOMER_ADDRESS_STATE,
  ADD_NEW_ADDRESS_STATE,
  UPDATE_CUSTOMER_STATE,
  ADD_NEW_ORDER_STATE,
  ADD_CUSTOMERS_STATE,
  ADD_NEW_SERVICES_STATE,
  ADD_NEW_DRIVERS_STATE,
  UPDATE_DRIVER_STATE,
  DATA_BASE_EXPORT_STATE,
  DATA_BASE_EXPORT,
  DATA_BASE_IMPORT,
  DATA_BASE_IMPORT_STATE,
  DATA_BASE_CUSTOMERS_IMPORT_STATE,
  DATA_BASE_SERVICES_IMPORT_STATE,
  DATA_BASE_DRIVERS_IMPORT_STATE,
  EXPORT_DATA_FILE_STATE,
} from "../constants/actions-types";

const initialState = {
  isExportingDatabase: false,
  isImportingDatabase: false,
  customers: [],
  drivers: [],
  services: [],
  selectedDriver: {},
  selectedOrder: {},
  selectedCustomer: undefined,
  customerInfo: {
    isEditProfile: false,
  },
  fetching: false,
  response: null,
  error: null,
  SendSMS: {
    fetching: false,
    response: null,
    error: null,
  },
  DEMO: {
    data: null,
    error: null,
    calling: false,
  },
  datafile: "",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXPORT_DATA_FILE_STATE:
      return { ...state, datafile: action.datafile };
    case DATA_BASE_EXPORT_STATE:
      return {
        ...state,
        isExportingDatabase: true,
        isImportingDatabase: false,
      };
    case DATA_BASE_CUSTOMERS_IMPORT_STATE:
      return {
        ...state,
        isExportingDatabase: false,
        isImportingDatabase: true,
      };
    case DATA_BASE_SERVICES_IMPORT_STATE:
      return {
        ...state,
        isExportingDatabase: false,
        isImportingDatabase: true,
      };
    case DATA_BASE_DRIVERS_IMPORT_STATE:
      return {
        ...state,
        isExportingDatabase: false,
        isImportingDatabase: true,
      };
    case "DEMO_CALL":
      return { ...state, DEMO: { ...state.DEMO, error: null, calling: true } };
    case "DEMO_SUCCESS":
      return {
        ...state,
        DEMO: { ...state.DEMO, data: action.res, calling: false },
      };
    case "DEMO_FAIL":
      return {
        ...state,
        DEMO: { ...state.DEMO, error: action.error, calling: false },
      };
    case API_SEND_SMS_REQUEST:
      return {
        ...state,
        SendSMS: { ...state.SendSMS, fetching: true, error: null },
      };
    case API_SEND_SMS_SUCCESS:
      return {
        ...state,
        SendSMS: {
          ...state.SendSMS,
          fetching: false,
          response: action.response,
        },
      };
    case API_SEND_SMS_FAILURE:
      return {
        ...state,
        SendSMS: {
          ...state.SendSMS,
          fetching: false,
          error: action.error,
          response: null,
        },
      };
    case API_CALL_REQUEST:
      return { ...state, fetching: true, error: null };
    case API_CALL_SUCCESS:
      return { ...state, fetching: false, response: action.response };
    case API_CALL_FAILURE:
      return { ...state, fetching: false, response: null, error: action.error };
    case ADD_NEW_CUSTOMER_STATE:
      return { ...state, customers: [action.customer, ...state.customers] };
    case EDIT_PROFILE__ADD_ADDRESS:
      return {
        ...state,
        customerInfo: { isEditProfile: action.isEditProfile },
      };
    case ADD_CUSTOMERS_STATE:
      return { ...state, customers: action.customers };
    case SELECT_CUSTOMER:
      return { ...state, selectedCustomer: action.selectCustomer };
    case ADD_NEW_SERVICES_STATE:
      return { ...state, services: action.services };
    case ADD_NEW_SERVICE_STATE:
      return { ...state, services: [action.service, ...state.services] };
    case REMOVE_SERVICE_STATE:
      let serviceIndex = state.services.findIndex(
        (x) => x._id == action.service._id
      );
      return {
        ...state,
        services: [
          ...state.services.slice(0, serviceIndex),
          ...state.services.slice(serviceIndex + 1),
        ],
      };
    case SELECT_DRIVER:
      return { ...state, selectedDriver: action.driver };
    case ADD_NEW_DRIVERS_STATE:
      return { ...state, drivers: action.drivers };
    case ADD_NEW_DRIVER_STATE:
      return { ...state, drivers: [action.driver, ...state.drivers] };
    case REMOVE_DRIVER_STATE:
      let driverIndex = state.drivers.findIndex(
        (x) => x._id == action.driver._id
      );
      return {
        ...state,
        drivers: [
          ...state.drivers.slice(0, driverIndex),
          ...state.drivers.slice(driverIndex + 1),
        ],
      };
    case REMOVE_CUSTOMER_ADDRESS_STATE:
      let index = state.selectedCustomer.addresses.findIndex(
        (x) => x._id == action.address._id
      );
      state = {
        ...state,
        selectedCustomer: {
          ...state.selectedCustomer,
          addresses: [
            ...state.selectedCustomer.addresses.slice(0, index),
            ...state.selectedCustomer.addresses.slice(index + 1),
          ],
        },
      };
      return {
        ...state,
        customers: state.customers.map((customer) => {
          if (customer._id == state.selectedCustomer._id) {
            return state.selectedCustomer;
          } else {
            return customer;
          }
        }),
      };
    case ADD_NEW_ADDRESS_STATE:
      let newState = {
        ...state,
        customers: state.customers.map((customer) => {
          if (customer._id == state.selectedCustomer._id) {
            let tempCustomer = {
              ...state.selectedCustomer,
              addresses: [
                action.address,
                ...(state.selectedCustomer.addresses || []),
              ],
            };
            return tempCustomer;
          } else {
            return customer;
          }
        }),
      };
      return {
        ...newState,
        selectedCustomer: {
          ...newState.selectedCustomer,
          addresses: [action.address, ...newState.selectedCustomer.addresses],
        },
      };
    case UPDATE_DRIVER_STATE:
      return {
        ...state,
        selectedDriver: action.driver,
        drivers: state.drivers.map((driver) => {
          if (driver._id == action.driver._id) {
            return action.driver;
          } else {
            return driver;
          }
        }),
      };
    case UPDATE_CUSTOMER_STATE:
      return {
        ...state,
        selectedCustomer: action.customer,
        customers: state.customers.map((customer) => {
          if (customer._id == action.customer._id) {
            return action.customer;
          } else {
            return customer;
          }
        }),
      };
    case ADD_NEW_ORDER_STATE:
      state = {
        ...state,
        selectedCustomer: {
          ...state.selectedCustomer,
          orders: [action.order, ...(state.selectedCustomer.orders || [])],
        },
      };

      return {
        ...state,
        customers: state.customers.map((customer) => {
          if (customer._id == state.selectedCustomer._id) {
            return state.selectedCustomer;
          } else {
            return customer;
          }
        }),
      };
    case SELECT_ORDER:
      return {
        ...state,
        selectedOrder: action.order,
      };
    default:
      return state;
  }
};

export default rootReducer;
